export default __webpack_public_path__ + "static/media/godwoken.1a52d42d.svg";